<template>
  <div>

    <!--导航栏 start-->
    <van-nav-bar title="添加门店" left-text="返回" left-arrow fixed @click-left="onClickLeft" />
    <!--导航栏 end-->
    <div class="container-logo">
      <img class="logo" src="@/assets/images/logo.png" alt="">
      <div class="title">添加门店</div>
    </div>

    <!--内容部分 start-->
    <van-form style="margin-top: 1.5rem" @submit="onSubmit">
      <van-field
        v-model="username"
        name="门店编号"
        left-icon="contact"
        placeholder="请输入门店编号"
        :rules="[{ required: true, message: '门店编号不能为空' }]"
      >
        <template #left-icon>
          <img class="login-icon" src="@/assets/images/login-user.png" alt="">
        </template>
      </van-field>
      <van-field
        v-model="password"
        type="password"
        name="密码"
        left-icon="goods-collect-o"
        placeholder="请输入密码"
        :rules="[{ required: true, message: '密码不能为空' }]"
      >
        <template #left-icon>
          <img class="login-icon" src="@/assets/images/login-password.png" alt="">
        </template>
      </van-field>
    </van-form>
    <div style="margin: 16px;">
      <van-button round block type="info" native-type="submit" @click="onSubmit">
        确定
      </van-button>
    </div>
    <!--内容部分 end-->

  </div>
</template>

<script>
// import VueCookie from 'vue-cookies'
import { Notify, Toast } from 'vant'
export default {
  name: 'MerchantLogin', // 门店添加
  data() {
    return {
      username: '',
      password: ''

    }
  },
  // 组件内路由--进入组件时
  beforeRouteEnter(to, from, next) {
    window.document.body.style.backgroundColor = '#f5f5f5'
    next()
  },
  // 组件内路由--离开组件时
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = ''
    next()
  },
  methods: {
    // 左侧返回
    onClickLeft() {
      this.$router.push('/StoreImpower')
      // window.history.go(-1)
    },
    // 提交
    onSubmit() {
      // window.sessionStorage.setItem("tag",this.ta)
      //  var that = this;
      var toast = Toast.loading({
        duration: 0,
        message: '登录中',
        forbidClick: true,
        loadingType: 'spinner'
      })
      // console.log('submit', values);
      this.$http.get('/wechat/user/store_login', {
        params: {
          username: this.username,
          password: this.password,
          openid: window.localStorage.getItem('openid')
        }
      }).then(response => {
        toast.clear()
        console.log(response.data)
        if (response && response.data.code == 200) {
          this.$router.push('/StoreImpower')

          // VueCookie.set('salesmanInfo', response.data.data, 360000);
          // window.location.href = that.redirect;
        } else {
          Notify({ type: 'danger', message: response.data.msg })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.container-logo {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 100px;
  // padding-top: 60px;
  height: 100px;

  .title {
    font-size: 20px;
    color: rgba(0, 0, 0, 1);
    margin-top: 20px;
  }

  .logo {
    width: 80px;
    height: 80px;
  }
}

.list {
  margin-top: 1rem;
  padding: 0.5rem;
  white-space: nowrap;
}

.login-icon {
  width: 18px;
  margin-top: 5px;
  margin-right: 16px;
}

::v-deep .van-field__left-icon {
  margin-right: 0.10667rem;
  display: flex;
  align-items: center;
}
</style>
